import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import VersionHistory from 'src/components/common/VersionHistory';
import { archLevel } from 'src/data/config';
import SiteQualificationConfirmationLetter from './SiteQualitficationConfirmationLetter';
import { DataTable } from '@pihealth/common-ui-library';
import staticData from '../../../../resources/static.json';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSqConfirmationLetter } from './useSqConfirmationLetter';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
export default function DataGridSQConfirmationLetter(props: any) {
  const { siteStudyData, setSqConfirmLetterOpen, setStudyLogOpen } = props;
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [headerTitle, setHedertitle] = useState('');
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [docId, setDocId] = useState('');
  const dispatch = useAppDispatch();
  const assignedColoumns = staticData.SQLetters.columns;
  const [openSQConfLetter, setOpenSQConfLetter] = useState(false);
  const [viewNTFGrid, setNTFGrid] = useState(true);
  const [rows, setRows] = useState([]);
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();
  const [sqvisitData, setSqvisitData] = useState({} as any);

  const { getSqConfrimationLetter, sqConfrimationLetterData, sqConfrimationLetterIsLoading } =
    useSqConfirmationLetter();

  const handelBack = () => {
    setStudyLogOpen(true);
  };

  const [selectedRow, setselectedRow] = useState<any>(null);

  useEffect(() => {
    if (checkPermission('view_sq_confirmationletter') && viewNTFGrid) {
      getSqConfrimationLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
    }
  }, [viewNTFGrid, selectedSite, selectedCountry]);

  useEffect(() => {
    if (sqConfrimationLetterData) {
      setSqvisitData(sqConfrimationLetterData);
      setRows(
        sqConfrimationLetterData?.map((item: any) => {
          return {
            ...item,
            major_version: Number(item.major_version).toFixed(1).toString(),
            updated_on: getPreferredDateTimeInLocal(item.updated_on),
            start_date: getPreferredDateTimeInLocal(item.start_date)
          };
        })
      );
    }
  }, [sqConfrimationLetterData]);

  useEffect(() => {
    if (selectedSite === null) {
      handelBack();
    }
  }, [studyId, selectedCountry, selectedSite]);

  const handleClick = (row: any) => {
    if (archLevel === 'site') {
      if (checkPermission('publishview_siqualifi_confirmationletter')) {
        if (row.major_version === '0.0') {
          dispatch(setMessage({ msgDetails: `${row.visit_name} not yet published`, severity: 'error' }));
        } else {
          if (!isHierarchyLevelClosed) {
            setOpenSQConfLetter(true);
            setNTFGrid(false);
            setselectedRow(row);
          } else {
            dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
          }
        }
      } else {
        dispatch(setMessage({ msgDetails: `Do not have required permission to view the letter`, severity: 'error' }));
      }
    } else {
      if (!isHierarchyLevelClosed) {
        setOpenSQConfLetter(true);
        setNTFGrid(false);
        setselectedRow(row);
      } else {
        dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
      }
    }
  };

  const versionClick = (versionData: any) => {
    setHedertitle(versionData.visit_name);
    setDocId(versionData.tp_document_id);
    setShowVersionHistory(true);
  };

  const actions = {
    visit_name: (data: any) => {
      handleClick(data);
    },
    major_version: (data: any) => {
      versionClick(data);
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`SQ Confirmation Letters`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <div>
      {viewNTFGrid ? (
        <>
          <div>
            <Box sx={{ marginBottom: 1, mt: -1 }}>
              <Button
                className="mainBackBtnWrap"
                onClick={() => handelBack()}
                startIcon={<ArrowBackIcon fontSize="small" />}
              >
                LIST OF LOGS
              </Button>
            </Box>
          </div>

          <div style={{ height: '74vh', width: '100%' }}>
            <div style={{ display: 'flex', height: '100%' }}>
              <div style={{ flexGrow: 1 }}>
                <DataTable
                  columns={assignedColoumns}
                  rows={rows}
                  loading={sqConfrimationLetterIsLoading}
                  disableSelectionOnClick={false}
                  pagination
                  className="studylogDatagrid"
                  exportAll
                  actions={actions}
                  datePreference={userPreferedDateFormat}
                  height="74vh"
                  showDateAndTime
                  hasDefinedDataGridToolbarExport
                  definedGridToolbarExport={definedCustomDatGridExport}
                />
              </div>
            </div>
          </div>
        </>
      ) : null}

      {openSQConfLetter ? (
        <SiteQualificationConfirmationLetter
          siteStudyData={siteStudyData}
          sqvisitData={sqvisitData}
          setSqConfirmLetterOpen={setSqConfirmLetterOpen}
          setOpenSQConfLetter={setOpenSQConfLetter}
          setStudyLogOpen={setStudyLogOpen}
          setNTFGrid={setNTFGrid}
          selectedRow={selectedRow}
        />
      ) : null}
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'STUDY LOGS'}
        />
      ) : null}
    </div>
  );
}
